import { useState, useEffect } from "react";
import * as ReactBootStrap from "react-bootstrap";

import FormData from "form-data";

import axios from "axios";

function BankAnlyze() {
    const [cardData, setCardData] = useState({
        Document_type: "",
        bank_name: "",
        from_date: "",
        to_date: "",
        account_no: "",
        holder_name: "",
        ifsc_code: "",
        document_type: "",
        status: "",
    });
    const [img, setImg] = useState();
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        // console.log("ththth", cardData);
    }, [cardData]);

    const onChange = (e) => {
        var file = e.target.files[0];
        let base64String = "";

        var reader = new FileReader();
        // console.log("next");

        reader.onload = function () {
            base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
            // console.log("base64String", base64String);
            setImg("b " + base64String);
        };
        reader.readAsDataURL(file);
    };

    const submit = () => {
        setLoading(false);
        setCardData({
            Document_type: "",
            from_date: "",
            to_date: "",
            account_no: "",
            holder_name: "",
            ifsc_code: "",
            document_type: "",
            status: "",
            bank_name: "",
        });
        var data = new FormData();
        data.append("ImageByte", img);
        var config = {
            method: "post",
            url: "https://idkd2turth.execute-api.ap-south-1.amazonaws.com/default/ainxt_bankstatement_analyzer",
            headers: {
                "x-api-key": "hY2CRZTMf8ylvEniO3gR3JA23QsbABJ1Rk5bm9Yg",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                console.log(JSON.stringify(response.data));
                setCardData(response.data);
                setLoading(true)
            })
            .catch(function (error) {
                setLoading(true)
                alert("Something went wrong with server");
                // console.log(error);
            });
    };

    useEffect(() => { }, [cardData]);
    return (
        <div className="container my-4">
            <h2 className="text-center mb-4">Bank Analysis</h2>

            {/* File Upload and Submit Button */}
            <div className="row justify-content-center mb-4">
                <div className="col-md-4 text-center">
                    <input type="file" className="form-control" onChange={onChange} />
                </div>
                <div className="col-md-2 text-center">
                    {loading ? (
                        <button className="btn btn-primary" onClick={submit}>
                            Submit
                        </button>
                    ) : (
                        <ReactBootStrap.Spinner animation="border" />
                    )}
                </div>
            </div>

            {/* Static Table for Basic Information */}
            {cardData.document_type && (
                <div className="mb-4">
                    <h3>Account Details</h3>
                    <table className="table table-bordered table-hover">
                        <tbody>
                            <tr>
                                <th>Document Type</th>
                                <td>{cardData.document_type}</td>
                            </tr>
                            <tr>
                                <th>Status</th>
                                <td>{cardData.status}</td>
                            </tr>
                            <tr>
                                <th>Bank Name</th>
                                <td>{cardData.bank_name}</td>
                            </tr>
                            <tr>
                                <th>From Date</th>
                                <td>{cardData.from_date}</td>
                            </tr>
                            <tr>
                                <th>To Date</th>
                                <td>{cardData.to_date}</td>
                            </tr>
                            <tr>
                                <th>Account Number</th>
                                <td>{cardData.account_no}</td>
                            </tr>
                            <tr>
                                <th>Holder Name</th>
                                <td>{cardData.holder_name}</td>
                            </tr>
                            <tr>
                                <th>IFSC Code</th>
                                <td>{cardData.ifsc_code}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}

            {/* Monthly Expense Table */}
            {cardData.monthly_expense && Object.keys(cardData.monthly_expense).length > 0 && (
                <div className="mb-4">
                    <h3>Monthly Expenses</h3>
                    <table className="table table-bordered table-hover">
                        <thead className="table-dark">
                            <tr>
                                <th>Month</th>
                                <th>Expense Credit</th>
                                <th>Income Credit</th>
                                <th>Expense Debit</th>
                                <th>Income Debit</th>
                                <th>Net Income</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(cardData.monthly_expense).map(([month, data]) => (
                                <tr key={month}>
                                    <td>{month}</td>
                                    <td>{data.Expense_credit || "-"}</td>
                                    <td>{data.Income_credit || "-"}</td>
                                    <td>{data.Expense_debit || "-"}</td>
                                    <td>{data.Income_debit || "-"}</td>
                                    <td>{data.Net_Income || "-"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Transactions Accordion */}
            {cardData.transactions && Object.keys(cardData.transactions).length > 0 && (
                <div>
                    <h3>Transactions</h3>
                    <ReactBootStrap.Accordion defaultActiveKey="0">
                        {Object.entries(cardData.transactions).map(([date, transactions], index) => (
                            <ReactBootStrap.Accordion.Item eventKey={index.toString()} key={date}>
                                <ReactBootStrap.Accordion.Header>
                                    {date} ({transactions.length} Transactions)
                                </ReactBootStrap.Accordion.Header>
                                <ReactBootStrap.Accordion.Body>
                                    <table className="table table-bordered table-hover">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Description</th>
                                                <th>Debit</th>
                                                <th>Credit</th>
                                                <th>Balance</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {transactions.map((transaction, idx) => (
                                                <tr key={idx}>
                                                    <td>{transaction.description || "-"}</td>
                                                    <td>{transaction.debit || "-"}</td>
                                                    <td>{transaction.credit || "-"}</td>
                                                    <td>{transaction.balance || "-"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </ReactBootStrap.Accordion.Body>
                            </ReactBootStrap.Accordion.Item>
                        ))}
                    </ReactBootStrap.Accordion>
                </div>
            )}
        </div>
    );

}

export default BankAnlyze;
